/**
 * Fantasy Console 0 - Vim Mode Indicator
 *
 * Displays the current vim mode (NORMAL, INSERT, VISUAL, etc.)
 */

import { VimMode } from './CodeEditor'
import styles from './VimModeIndicator.module.css'

interface VimModeIndicatorProps {
  mode: VimMode
}

export function VimModeIndicator({ mode }: VimModeIndicatorProps) {
  const modeClass = mode.toLowerCase().replace(' ', '-')
  return (
    <span className={`${styles.indicator} ${styles[modeClass]}`}>
      -- {mode} --
    </span>
  )
}
